import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/InvOrders/ReportPurchasePlanInvOrderLoadLoad',
    method: 'post',
    data
  });
}

export function getloadfile(data) {
  return request({
    url: '/InvOrders/GetReportPurchasePlanInvOrderLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

// 更新库存状态
export function AsyncStoreState() {
  return request({
    url: '/InvOrderDetails/AsyncStoreState',
    method: 'get'
  });
}
